import { useIntl } from "react-intl";
import { useEffect, useMemo, useState, useRef, CSSProperties } from "react";
import moment from "moment";
// MUI
import { makeStyles } from "@mui/styles";

import { Button, Dropdown, Form, Header, Icon, Input, Modal, TextArea } from "semantic-ui-react";
import EmployeeToken from "react-lib/apps/common/EmployeeToken";
import ModConfirm from "react-lib/apps/common/cnmi/ModConfirm";
import ModInfo from "react-lib/apps/common/ModInfo";

import SubTreatmentPerformRow from "./SubTreatmentPerformRow";
import SubTreatmentRecord from "./SubTreatmentRecord";
import SubTreatmentPlanRow from "./SubTreatmentPlanRow";

// Utils
import { beToAd } from "react-lib/utils/dateUtils";
import ModalEditImage from "react-lib/apps/common/ModalEditImage";
import CardImageGallery from "react-lib/apps/DPO/CardImageGallery";

const useStyles = makeStyles((theme) => ({
  inputNumber: {
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
}));

type SortDataType = { accessor?: string; orderBy?: "ASC" | "DESC" };

const styles = {
  borderStyle: "solid #dddddd 0.5px",
  bgColor: "#2D9CDB",
  rightLable: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    paddingRight: "6px",
  } as CSSProperties,
  labelStyle: {
    marginTop: "3px",
    padding: "5px",
    wordBreak: "break-word",
  } as CSSProperties,
  centerStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  } as CSSProperties,
};

const BE_DATE_FORMAT = "YYYY-MM-DD";

const treatmentPerformColumnDef = [
  { name: "\u00a0", width: 80 },
  { name: "Treatment", width: 100 },
  { name: "Location", width: 80 },
  { name: "Treatment Code", width: 120 },
  { name: "Price Level", width: 100 },
  { name: "Price / Unit", width: 50 },
  { name: "Unit", width: 40 },
  { name: "Total Fee", width: 70 },
  { name: "Treatment Record", width: 70 },
];

const ButtonSort = (props: any) => {
  const isActive = useMemo(() => {
    return props.value?.accessor === props.accessor;
  }, [props.value?.accessor, props.accessor]);

  const convert: any = useMemo(() => {
    return {
      ASC: "DESC",
      DESC: "ASC",
    };
  }, []);

  return (
    <div
      className={`header-button-sort${isActive ? " active" : ""}`}
      onClick={() => {
        props.onClick({
          accessor: props.accessor,
          orderBy: !props.value.orderBy || !isActive ? "ASC" : convert[props.value.orderBy],
        });
      }}
    >
      <label>{props.label}</label>
      <div className={props.value?.orderBy} style={{ display: "grid" }}>
        <Icon name="caret up" style={{ marginTop: "-6px", marginBottom: "-3px" }} />
        <Icon name="caret down" />
      </div>
    </div>
  );
};

type TreatmentTodayProps = {
  hideMenuHIS?: boolean;
  handleEvent?: any; // PropTypes.func,
  setProp?: any; // PropTypes.func,
  statusExcludeCompleteOptions?: any[]; // PropTypes.array,
  treatmentOptions?: any[]; // PropTypes.array,
  priceChangeReasonOptions?: any[];
  urgencyOptions?: any[]; // PropTypes.array,
  anestheticOptions?: any; // PropTypes.array,
  encounterId?: number; // PropTypes.number,
  divisionHasUserOptions?: any;
  treatmentPlanList?: any[]; // PropTypes.array,
  treatmentPerformList?: any[]; // PropTypes.array,
  keyboardShortcut?: boolean; // PropTypes.bool,
  modConfirmTreatmentPlan?: boolean; // PropTypes.bool,
  showClinicalFindingTerms?: boolean; // PropTypes.bool,
  cardFilterDentistElement?: any; // PropTypes.element,
  cardFilterUrgencyLevelElement?: any; // PropTypes.element,
  treatmentPlanReadOnly?: boolean;
  treatmentPerformReadOnly?: boolean;
  encounterInfo?: any;
  studentLocked?: boolean;
};

const TreatmentToday = (props: TreatmentTodayProps) => {
  const intl = useIntl();
  const [selectedTreatmentPlan, setSelectedTreatmentPlan] = useState<any>(null);
  const [selectedTreatmentPerform, setSelectedTreatmentPerform] = useState<any>(null);
  const [insertAfterId, setInsertAfterId] = useState<string>("");
  const [treatmentPlanList, setTreatmentPlanList] = useState<any[]>([]);
  const [sortData, setSortData] = useState<SortDataType>({});

  // treatmentPerformReadOnly turns on when encounter is checked out / discharged / student locked (see DPO.tsx)
  const denApproveStatus = props.encounterInfo?.den_approve_status;
  // full read-only: encounter ปิดเคสและเป็นเคสที่จบ flow แล้ว (BLANK = legacy ไม่เคยเข้า approve, APPROVED = "Checkout"/Approve)
  const lockedAfterApproval = props.treatmentPerformReadOnly && ["BLANK", "APPROVED"].includes(denApproveStatus);
  // partial lock: encounter ปิดเคสแต่ยังอยู่ใน approve flow (DRAFT/FINISH_EDITING)
  const lockedInDraftOrFinishEditing = props.treatmentPerformReadOnly && ["DRAFT", "FINISH_EDITING"].includes(denApproveStatus);

  useEffect(() => {
    props.handleEvent({ message: "GetTreatmentTodayMasterData" });

    props.handleEvent({ message: "refreshCurrentTreatment", params: { isFetchTreatmentIssue: !props.hideTreatmentPerform } });
  }, []);

  useEffect(() => {
    props.handleEvent({ message: "refreshCurrentTreatment", params: { isFetchTreatmentIssue: !props.hideTreatmentPerform } });

    setSelectedTreatmentPerform(null);
  }, [props.encounterId]);

  useEffect(() => {
    sortTreatmentPlan();
  }, [props.treatmentPlanList, sortData]);

  useEffect(() => {
    // console.log("useEffect toggleInteractivity props.encounterInfo: ", props.encounterInfo)
    const performPaid = document.querySelectorAll(".body-treatment-perform > div.paid-disabled")
    const performWithoutPaid = document.querySelectorAll(".body-treatment-perform > div:not(.paid-disabled)");

    const plan = document.querySelector(".body-treatment-plan");

    if (props.encounterInfo && (props.treatmentPerformList || []).length > 0) {
      setTimeout(() => {

        performPaid.forEach((value,key,parent) => {
          toggleInteractivity(false, value);
        })
        performWithoutPaid.forEach((value,key,parent) => {
          toggleInteractivity(!props.treatmentPerformReadOnly, value);
        })

      }, 300);
    }

    if (props.encounterInfo && (props.treatmentPlanList || []).length > 0) {
      setTimeout(() => {
        console.log('!!!! props.treatmentPlanReadOnly: ', props.treatmentPlanReadOnly);
        toggleInteractivity(!props.treatmentPlanReadOnly, plan);
      }, 300);
    }

  }, [props.encounterInfo, props.treatmentPlanReadOnly, props.treatmentPerformReadOnly, props.treatmentPlanList, props.treatmentPerformList]);

  // const handleSortTreatmentPlan = (data: SortDataType) => {
  //   setSortData(data);
  // };

  const sortTreatmentPlan = () => {
    if (!sortData.accessor) {
      setSortData({ accessor: "display_seq", orderBy: "ASC" });
      // setTreatmentPlanList(props.treatmentPlanList);
      // return;
    }

    const filter = props.treatmentPlanList?.sort((a: any, b: any) => {
      const [first, second] = (sortData.accessor || "").split(".");
      let aValue = a[first];
      let bValue = b[first];

      if (first === "created") {
        aValue = beToAd(aValue)?.format(BE_DATE_FORMAT);
        bValue = beToAd(bValue)?.format(BE_DATE_FORMAT);
      }
      if (second) {
        aValue = aValue[second];
        bValue = bValue[second];
      }

      const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });

      if (sortData.orderBy === "ASC" && aValue) {
        return collator.compare(aValue?.toString(), bValue.toString());
      } else if (sortData.orderBy === "DESC") {
        return collator.compare(bValue.toString(), aValue?.toString());
      }

      return 0;
    });
    console.log(filter);
    setTreatmentPlanList([...filter]);
  };

  const isActive = (list: any[]) => {
    return list.find((item: any) => item.is_selected === false);
  };

  const treatmentPlanColumnDef = useMemo(
    () => [
      { name: "Seq", width: 90 },
      { name: "\u00a0", width: 85 },
      {
        name: (
          <div style={{ display: "flex", alignItems: "baseline", justifyContent: "center" }}>
            Location
            <Icon
              className="treatment-today-filter-location"
              name="filter"
              style={{ marginLeft: "5px", cursor: "pointer", zIndex: 2, color: isActive(props.currentLocationFilterListTp) ? "yellow" : "" }}
              onClick={() => props.setProp("openModalFilterCurrentLocation", true)}
            />
          </div>
        ),
        width: 100,
      },
      {
        name: (
          <div style={{ display: "flex", alignItems: "baseline", justifyContent: "center" }}>
            Medical Terms / ICD10
            <Icon
              className="treatment-today-filter-principal"
              name="filter"
              style={{ marginLeft: "5px", cursor: "pointer", zIndex: 2, color: isActive(props.currentPrincipalFilterListTp) ? "yellow" : "" }}
              onClick={() => props.setProp("openModalFilterCurrentPrincipal", true)}
            />
          </div>
        ),
        width: 105,
      },
      {
        name: (
          <div style={{ display: "flex", alignItems: "baseline", justifyContent: "center" }}>
            Treatment Plan
            <Icon
              className="treatment-today-filter-tp"
              name="filter"
              style={{ marginLeft: "5px", cursor: "pointer", zIndex: 2, color: isActive(props.currentTpFilterListTp) ? "yellow" : "" }}
              onClick={() => props.setProp("openModalFilterCurrentTp", true)}
            />
          </div>
        ),
        width: 95,
      },
      { name: "Estimate visit", width: 50 },
      {
        name: (
          <div style={{ display: "flex", alignItems: "baseline", justifyContent: "center" }}>
            Clinic
            <Icon
              className="treatment-today-filter-clinic"
              name="filter"
              style={{ marginLeft: "5px", cursor: "pointer", zIndex: 2, color: isActive(props.currentClinicFilterListTp) ? "yellow" : "" }}
              onClick={() => props.setProp("openModalFilterCurrentClinic", true)}
            />
          </div>
        ),
        width: 80,
      },
      {
        name: (
          <div style={{ display: "flex", alignItems: "baseline", justifyContent: "center" }}>
            {intl.formatMessage({ id: "cukey313" })}
            <Icon
              className="treatment-today-filter-dentist"
              name="filter"
              style={{ marginLeft: "5px", cursor: "pointer", zIndex: 2, color: isActive(props.dentistFilterListTp) ? "yellow" : "" }}
              onClick={() => props.setProp("openModalFilterDentist", true)}
            />
          </div>
        ),
        width: 80,
      },
      {
        name: (
          <div style={{ display: "flex", alignItems: "baseline", justifyContent: "center" }}>
            Status
            <Icon
              className="treatment-today-filter-status"
              name="filter"
              style={{ marginLeft: "5px", cursor: "pointer", zIndex: 2, color: isActive(props.currentStatusFilterListTp) ? "yellow" : "" }}
              onClick={() => props.setProp("openModalFilterCurrentStatus", true)}
            />
          </div>
        ),
        width: 75,
      },
      {
        name: (
          <div style={{ display: "flex", alignItems: "baseline", justifyContent: "center" }}>
            {intl.formatMessage({ id: "cukey369" })}
            <Icon
              className="treatment-today-filter-urgency"
              name="filter"
              style={{ marginLeft: "5px", cursor: "pointer", zIndex: 2, color: isActive(props.urgencyLevelFilterListTp) ? "yellow" : "" }}
              onClick={() => props.setProp("openModalFilterUrgencyLevel", true)}
            />
          </div>
        ),
        width: 75,
      },
      {
        name: (
          <div style={{ display: "flex", alignItems: "baseline", justifyContent: "center" }}>
            Created
            <Icon
              className="treatment-today-filter-created"
              name="filter"
              style={{ marginLeft: "5px", cursor: "pointer", zIndex: 2, color: isActive(props.currentCreatedFilterListTp) ? "yellow" : "" }}
              onClick={() => props.setProp("openModalFilterCurrentCreated", true)}
            />
          </div>
        ),
        width: 70,
      },
    ],
    [
      props.dentistFilterListTp,
      props.urgencyLevelFilterListTp,
      props.currentLocationFilterListTp,
      props.currentPrincipalFilterListTp,
      props.currentTpFilterListTp,
      props.currentClinicFilterListTp,
      props.currentStatusFilterListTp,
      props.currentCreatedFilterListTp,
    ]
  );

  const calculateGridTemplate = (treatmentColumnDef: any) => {
    const widths = treatmentColumnDef.map((column: any) => column.width);
    const sumWidth = widths.reduce((acc: number, cur: number) => acc + cur, 0);
    return widths
      .map((width: number) => (100.0 * width) / sumWidth)
      .map((pct: number) => pct.toString() + "%")
      .join(" ");
  };

  const gridTemplateColumnsTreatmentPerform = useMemo(() => calculateGridTemplate(treatmentPerformColumnDef), []);

  const gridTemplateColumnsTreatmentPlan = useMemo(() => calculateGridTemplate(treatmentPlanColumnDef), []);

  // ---------- Treatment Record
  const handleSelectedTreatmentRecord = (treatmentPerform: any) => {
    props.handleEvent({
      message: "HandleSetSelectTreatmentRecord",
      params: {
        treatmentPerform: treatmentPerform,
        onCallBack: (data: any) => {
          setSelectedTreatmentPerform({ ...data });
        },
      },
    });
    // setSelectedTreatmentPerform({ ...treatmentPerform });
  };

  const handleCloseTreatmentRecord = () => {
    setSelectedTreatmentPerform(null);
  };

  // ---------- Cancel Treatment Plan
  const handleCloseMod = () => {
    props.setProp("modConfirmTreatmentPlan.open", false);
  };

  const handleCancelTreatmentPlan = (treatmentPlan: any) => {
    setSelectedTreatmentPlan(treatmentPlan);
    props.setProp("modConfirmTreatmentPlan.open", true);
  };

  const handleCloseModChangeDisplaySeq = async () => {
    await props.setProp("openModChangeDisplaySeq", false);
    props.setProp("isMainLoading", false);
  };

  // console.log('TreatmentToday selectedTreatmentPerform: ', selectedTreatmentPerform);
  // console.log('TreatmentToday props.showClinicalFindingTerms: ', props.showClinicalFindingTerms);

  let treatmentPerformList = useMemo(() => {
    let treatmentPlans = (props.treatmentPerformList || []).sort((a:any, b:any) => a.id - b.id)
      ?.filter((i: any) => i.treatment_plan?.id)
      ?.map((i: any) => i.treatment_plan?.id);

    let uniqueTP = [...new Set(treatmentPlans)];
    let treatmentPL: any[] = []
    // console.log('uniqueTP: ', uniqueTP);


    uniqueTP.forEach((uni: number) => {
      let [first, ...rest] = (props.treatmentPerformList || [])?.filter((t: any) => t.treatment_plan?.id === uni)
      // console.log('treatmentPerformList rest: ', rest);
      // console.log('treatmentPerformList first: ', first);
      let groups = [first, ...rest]
      if (rest?.length > 0) {
        groups = groups.map((i: any) => ({...i, haveSubRow: true, parentRow: false}))
        groups[0].parentRow = true
        groups[groups.length - 1].haveSubRow = false
        groups[0].haveProductInside = groups?.some((i: any) => !!i.product)
      } else {
        groups[0].parentRow = true
        groups[0].haveSubRow = false
        groups[0].haveProductInside = !!groups[0].product
      }

      treatmentPL = treatmentPL.concat(groups)

    });

    return treatmentPL

  }, [props.treatmentPerformList, props.treatmentPerformReadOnly]);

  // console.log("TreatmentToday treatmentPerformList: ", treatmentPerformList);
  return (
    <div style={{ border: "1px solid #d4d4d5", padding: "10px" }}>
      {!props.hideTreatmentPerform && (
        <div className={props.treatmentPerformReadOnly ? "ui form --override-disabled --grey" : "ui form"}>
          <Header as="h4">
            <span style={{ marginLeft: "6px" }}>
              {intl.formatMessage({ id: "cukey210" })} &nbsp;&nbsp;&nbsp; ทั้งหมด {props.treatmentPerformList?.length} รายการ
            </span>
          </Header>
          <div>
            <div style={{ display: "grid", overflowY: "scroll", gridTemplateColumns: gridTemplateColumnsTreatmentPerform }}>
              {treatmentPerformColumnDef.map((column: any, column_index: number) => (
                <div
                  key={column_index}
                  style={{ border: styles.borderStyle, textAlign: "center", backgroundColor: styles.bgColor, color: "white", padding: "3px" }}
                >
                  {column.name}
                </div>
              ))}
            </div>
            <div className="body-treatment-perform" style={{ width: "100%", overflowY: "scroll", border: styles.borderStyle, minHeight: "100px" }}>
              {treatmentPerformList.map((treatmentPerform: any, index: number) => {
                return (
                  <SubTreatmentPerformRow
                    key={treatmentPerform.id}
                    index={index}
                    styles={styles}
                    gridTemplateColumnsTreatmentPerform={gridTemplateColumnsTreatmentPerform}
                    // function
                    handleEvent={props.handleEvent}
                    setProp={props.setProp}
                    handleSelectedTreatmentRecord={handleSelectedTreatmentRecord}
                    // option
                    treatmentOptions={props.treatmentOptions}
                    priceChangeReasonOptions={props.priceChangeReasonOptions}
                    // data
                    treatmentPerform={treatmentPerform}
                    selectedTreatmentPerform={selectedTreatmentPerform}
                    divisionHasUserOptions={props.divisionHasUserOptions}
                    encounterInfo={props.encounterInfo}
                    // config
                    hideMenuHIS={props.hideMenuHIS}
                    readOnly={props.treatmentPerformReadOnly || treatmentPerform.is_paid}
                    // #70104 Allow when not have TreatmentCode (parent or inside)
                    disabledRemoveBtn={
                      (lockedInDraftOrFinishEditing && !!treatmentPerform?.haveProductInside) || // #70104 has children
                      lockedAfterApproval ||
                      props.studentLocked || // #84506
                      treatmentPerform.is_paid // #70142
                    }
                    // #70021 Allow When DRAFT State
                    disabledContinueBtn={lockedAfterApproval || props.studentLocked}
                    changeUnit={(id: number, value: any) => {
                      const idx = props.treatmentPerformList?.findIndex((t) => t.id === id);
                      if (idx === -1) {
                        console.error("Can't find treatmentPerformList index");
                      } else {
                        props.setProp(`treatmentPerformList.${idx}.quantity`, value);
                      }
                    }}
                    totalRows={treatmentPerformList?.length}
                  />
                );
              })}
            </div>
          </div>
        </div>
      )}

      {!!selectedTreatmentPerform && (
        <SubTreatmentRecord

          handleEvent={props.handleEvent}
          handleCloseTreatmentRecord={handleCloseTreatmentRecord}
          selectedTreatmentPerform={selectedTreatmentPerform}
          anestheticOptions={props.anestheticOptions}
          setProp={props.setProp}
          showClinicalFindingTerms={props.showClinicalFindingTerms}
          keyboardShortcut={props.keyboardShortcut}
          // #70021
          readonly={lockedAfterApproval || props.studentLocked}
        />
      )}
      <Header as="h4">
        <Button
          color="green"
          disabled={!props.showButtonSaveSeq}
          onClick={() => {
            props.handleEvent({ message: "handleUpdateTreatmentPlanSeq" });
          }}
        >
          Save Seq
        </Button>
        <span style={{ marginLeft: "10px" }}>
          อัพเดตล่าสุด {moment(treatmentPlanList?.[0]?.edited).format("DD/MM/YYYY HH:mm น.")} &nbsp;&nbsp;&nbsp;
          {intl.formatMessage({ id: "cukey211" })} ทั้งหมด {treatmentPlanList?.length} รายการ
        </span>
      </Header>

      {props.cardFilterDentistElement}
      {props.cardFilterUrgencyLevelElement}
      {props.cardFilterCurrentLocationElement}
      {props.cardFilterCurrentPrincipalElement}
      {props.cardFilterCurrentTpElement}
      {props.cardFilterCurrentClinicElement}
      {props.cardFilterCurrentStatusElement}
      {props.cardFilterCurrentCreatedElement}

      <div className={props.treatmentPlanReadOnly ? "ui form --override-disabled --grey table-treatment-plan" : "table-treatment-plan"}>
        <div style={{ display: "grid", overflowY: "scroll", gridTemplateColumns: gridTemplateColumnsTreatmentPlan }}>
          {treatmentPlanColumnDef.map((column: any, column_index: number) => (
            <div
              key={column_index}
              style={{ border: styles.borderStyle, textAlign: "center", backgroundColor: styles.bgColor, color: "white", padding: "3px" }}
            >
              {column.name}
            </div>
          ))}
        </div>
        <div className="body-treatment-plan" style={{ width: "100%", overflowY: "scroll", border: styles.borderStyle, height: "300px" }}>
          {treatmentPlanList.map((treatmentPlan: any, index: number) => (
            <SubTreatmentPlanRow
              key={treatmentPlan.id}
              index={index}
              styles={styles}
              gridTemplateColumns={gridTemplateColumnsTreatmentPlan}
              // function
              handleEvent={props.handleEvent}
              setProp={props.setProp}
              handleCancelTreatmentPlan={handleCancelTreatmentPlan}
              setInsertAfterId={setInsertAfterId}
              // option
              urgencyOptions={props.urgencyOptions}
              statusExcludeCompleteOptions={props.statusExcludeCompleteOptions}
              // data
              encounterId={props.encounterId}
              treatmentPlan={treatmentPlan}
              insertAfterId={insertAfterId}
              openModChangeDisplaySeq={props.openModChangeDisplaySeq}
              length={treatmentPlanList?.length || 0}
              // config
              readOnly={props.treatmentPlanReadOnly}
            />
          ))}
        </div>
      </div>

      <ModConfirm
        titleName="ยืนยันยกเลิกวางแผนการรักษา"
        titleColor="red"
        modalStyle={{ width: "40%" }}
        openModal={props.modConfirmTreatmentPlan.open}
        content={
          <div style={{ marginBottom: "-0.5rem" }}>
            <Header as="h4">
              ระบุเหตุผลในการยกเลิกวางแผนการรักษา
              <label style={{ color: "red" }}> *</label>
            </Header>
            <Dropdown
              search
              selection
              className="fluidDropdown"
              options={props.treatmentTodayMasterData?.note_cancel_trt_plan || []}
              value={props.modConfirmTreatmentPlan?.canceled_reason || null}
              onChange={(e, data) => {
                const result = { ...props.modConfirmTreatmentPlan, canceled_reason: data.value };
                props.setProp("modConfirmTreatmentPlan", result);
              }}
            />
            <div style={{ display: "flex", alignItems: "baseline", marginTop: "1rem" }}>
              <Header as="h4">ผู้บันทึกข้อมูล</Header>
              <EmployeeToken
                placeholder="code"
                onEnterToken={(code) => {
                  props.handleEvent({
                    message: "GetEmployeeTokenization",
                    params: { code: code },
                  });
                }}
                onClearToken={async () => {
                  const result = { ...props.modConfirmTreatmentPlan, name: "", token: null, error: null };
                  await props.setProp("modConfirmTreatmentPlan", result);
                }}
                // error={props.modConfirmTreatmentPlan?.error}
                // loading={props.modConfirmTreatmentPlan?.loading}
                employeeName={props.modConfirmTreatmentPlan?.name}
                error={props.modConfirmTreatmentPlan?.error}
                inputStyle={{ width: "80%", marginLeft: "10px" }}
              />
            </div>
          </div>
        }
        onApprove={(e: any) => {
          props.handleEvent({
            message: "handleUpdateTreatmentPlan",
            params: {
              pk: selectedTreatmentPlan?.id,
              exam_id: selectedTreatmentPlan?.examination,
              status: "X",
              token: props.modConfirmTreatmentPlan?.token,
              type: "delete",
            },
          });
        }}
        onDeny={handleCloseMod}
        onCloseWithDimmerClick={handleCloseMod}
      />
      <ModInfo
        color="red"
        open={props.openModChangeDisplaySeq}
        titleName="แจ้งเตือน !"
        btnText="ปิด"
        buttonColor="blue"
        onApprove={handleCloseModChangeDisplaySeq}
      >
        <div style={{ margin: "-0.75rem 0px 0.5rem" }}>
          <div style={{ color: "red", fontWeight: "bold", marginBottom: "0.5rem" }}>ไม่สามารถปรับลำดับได้</div>
          <div>เนื่องจากรายการ Treatment plan ไม่ตรงตามเงื่อนไขการจัดการตามระดับความเร่งด่วน และ สถานะ</div>
        </div>
      </ModInfo>
      <ModalEditImage
        hidePeriodontium={true}
        image={{ image: process.env.PUBLIC_URL + "/static/images/toothDiagram.png" }}
        openEditModal={props.openGallery?.open}
        onCloseModal={() => {
          props.handleEvent({
            message: "HandleTreatmentIssueDrawing",
            params: {
              action: "CLOSE_DRAWING",
            },
          });
        }}
        cancelImage={() => {
          props.handleEvent({
            message: "HandleTreatmentIssueDrawing",
            params: {
              action: "CLOSE_DRAWING",
            },
          });
        }}
        editedImage={() => {}}
        editedImageOverlay={(data: any) => {
          props.handleEvent({
            message: "HandleTreatmentIssueDrawing",
            params: {
              data,
              treatment_issue: selectedTreatmentPerform,
              action: "SAVE_DRAWING",
            },
          });

          if (!!Object.keys(data).length) {
            setSelectedTreatmentPerform({ ...selectedTreatmentPerform, activeDrawing: true });
          }
        }}
        hiddenTab={false}
        activeTabs={props.openGallery?.activeTabs}
        imageOverlay={props.openGallery?.imageOverlayData}
        hideBabyTooth={props.openGallery?.hideBabyTooth || false}
      />

      <Modal open={props.treatmentIssueImageGallery?.open}>
        <CardImageGallery
          // onEvent={props.handleEvent}
          onCreateImage={(image: any, onSuccess: any) => {
            props.handleEvent({
              message: "HandleTreatmentIssueGallery",
              params: {
                action: "CREATE_IMAGE",
                treatment_issue: selectedTreatmentPerform,
                image,
                // onSuccess
              },
            });
          }}
          onClose={() => {
            props.handleEvent({
              message: "HandleTreatmentIssueGallery",
              params: {
                action: "CLOSE_GALLERY",
                selectedTreatmentPerform: selectedTreatmentPerform,
                onCallBack: (data: any) => {
                  setSelectedTreatmentPerform({ ...data });
                },
              },
            });
          }}
          onGetImage={() => {
            props.handleEvent({
              message: "HandleTreatmentIssueGallery",
              params: {
                action: "OPEN_GALLERY",
                treatment_issue: selectedTreatmentPerform,
              },
            });
          }}
          onRemoveImage={(selectedImage: any, imageDataURI: any, detail: any) => {
            props.handleEvent({
              message: "HandleTreatmentIssueGallery",
              params: {
                action: "DELETE_IMAGE",
                treatment_issue: selectedTreatmentPerform,
                selectedImage,
                imageDataURI,
                detail,
              },
            });
          }}
          onUpdateImage={(selectedImage: any, imageDataURI: any, detail: any) => {
            props.handleEvent({
              message: "HandleTreatmentIssueGallery",
              params: {
                action: "UPDATE_IMAGE",
                treatment_issue: selectedTreatmentPerform,
                selectedImage,
                imageDataURI,
                detail,
              },
            });
          }}
          // controller={this.cardImageGalleryController}
          // showTemplete={true}
          imageData={props.treatmentIssueImageGallery}
          hideHeaderIcon={false}
          showTemplete={false}
          patientData={props.patientData}
        />
      </Modal>
    </div>
  );
};

/* ------------------------------------------------------ */

/*                   toggleElementsInteractivity;                   */

/* ------------------------------------------------------ */
function blockInteraction(e: Event) {
  if (e.target instanceof HTMLElement) {
    e.target.blur();
  }

  e.preventDefault();
  e.stopPropagation();
}

const toggleInteractivity = (isEditable: boolean, target?: Element | null) => {

  let isEditableVal = isEditable;
  console.groupCollapsed("toggleInteractivity")
  console.log('toggleInteractivity isEditable: ', isEditable, " target: ", target );

  if (!target) {
    console.groupEnd()
    return;
  }

  const children = [...target.querySelectorAll("button, input, textarea, i, .dropdown, .menu, .checkbox, a, .input")] as HTMLElement[];
  // console.log('toggleInteractivity children: ', children);

  const isUIComponent = (elm: HTMLElement) => {
    const regex = /ui.*(?:input|dropdown)/i;

    let checked = regex.test(elm.className)
    // console.log('toggleInteractivity isUIComponent elm: ', elm);
    // console.log('toggleInteractivity isUIComponent checked: ', checked);
    return checked
  };

  for (const elm of children) {
    // console.log('!!!!!!! ------ toggleInteractivity -------- !!!!!!  elm: ', elm);
    if (elm.className.includes("ignore-prevent") || elm.id === "ignore-prevent") {
      console.log("ignore-prevent elm: ", elm)
      continue;
    }

    if (elm.className.includes("paid-disabled")) {
      isEditableVal = false
    } else {
      isEditableVal = isEditable
    }

    const isInteractiveElement = ["INPUT", "TEXTAREA"].includes(elm.tagName) || isUIComponent(elm);
    const isDisableable = isInteractiveElement && "disabled" in elm;
    const isClickableElement = ["A", "BUTTON", "I"].includes(elm.tagName) || isUIComponent(elm);

    // console.log('toggleInteractivity isDisableable: ', isDisableable);
    // console.log('toggleInteractivity isClickableElement: ', isClickableElement);
    // console.log('toggleInteractivity isInteractiveElement: ', isInteractiveElement);
    console.log('toggleInteractivity isEditable: ', isEditableVal);
    if (isEditableVal) {
      console.log('!!! Enable toggleInteractivity: !!! ', elm);
      // Enable interactivity
      for (const event of ["click", "keydown", "focus"]) {
        // console.log('toggleInteractivity removeEventListener: ');
        elm.removeEventListener(event, blockInteraction);
      }

      // Handle tabindex
      const originalTabIndex = elm.dataset.originalTabindex;

      if (originalTabIndex !== undefined) {
        if (originalTabIndex === "") {
          elm.removeAttribute("tabindex");
        } else {
          elm.setAttribute("tabindex", originalTabIndex);
        }

        delete elm.dataset.originalTabindex;
      }

      // Handle class
      if (isClickableElement) {
        elm.classList.remove("disabled")
        // const { originalClass } = elm.dataset;
        // console.log('originalClass: ', originalClass);
        // if (originalClass) {
          // delete elm.dataset.originalClass;
        // }
      }

      // Handle disabled state
      if (isDisableable && "originalDisabled" in elm.dataset) {
        (elm as HTMLInputElement).disabled = elm.dataset.originalDisabled === "true";
        delete elm.dataset.originalDisabled;
      }
    } else {
      // Disable interactivity
      console.log('!!! Disable toggleInteractivity: !!! ', elm);
      for (const event of ["click", "keydown", "focus"]) {
        elm.removeEventListener(event, blockInteraction);
        elm.addEventListener(event, blockInteraction);
      }

      // Handle tabindex
      if (!("originalTabindex" in elm.dataset)) {
        elm.dataset.originalTabindex = elm.getAttribute("tabindex") || "";
      }

      elm.setAttribute("tabindex", "-1");

      console.log('Check is need store elm.dataset: ', elm.dataset);
      // Handle class
      if (isClickableElement) {
        elm.classList.add("disabled")
      }
      // if (isClickableElement && !("originalClass" in elm.dataset)) {
        // console.log('Store elm.dataset: ', elm.dataset);
        // elm.dataset.originalClass = elm.className;
        // console.log('store elm.dataset.originalClass: ',  elm.dataset.originalClass);
      //   elm.classList.add("disabled");
      // }

      // Handle disabled state
      if (isDisableable) {
        if (!("originalDisabled" in elm.dataset)) {
          elm.dataset.originalDisabled = (elm as HTMLInputElement).disabled.toString();
        }

        (elm as HTMLInputElement).disabled = true;
      }
    }
    // console.log("!!!!!!! ------ toggleInteractivity END -------- !!!!!! ")
  }

  console.groupEnd()
};

// TreatmentToday.propTypes = {
//   handleEvent: PropTypes.func,
//   setProp: PropTypes.func,

//   statusExcludeCompleteOptions: PropTypes.array,
//   treatmentOptions: PropTypes.array,
//   urgencyOptions: PropTypes.array,
//   anestheticOptions: PropTypes.array,

//   encounterId: PropTypes.number,
//   treatmentPlanList: PropTypes.array,
//   treatmentPerformList: PropTypes.array,
//   keyboardShortcut: PropTypes.bool,
//   modConfirmTreatmentPlan: PropTypes.bool,

//   showClinicalFindingTerms: PropTypes.bool,

//   cardFilterDentistElement: PropTypes.element,
//   cardFilterUrgencyLevelElement: PropTypes.element,
// };

TreatmentToday.defaultProps = {
  handleEvent: () => {},
  setProp: () => {},

  statusExcludeCompleteOptions: [],
  treatmentOptions: [],
  urgencyOptions: [],
  anestheticOptions: [],

  encounterId: null,
  treatmentPlanList: [],
  treatmentPerformList: [],
  keyboardShortcut: [],
  modConfirmTreatmentPlan: false,

  showClinicalFindingTerms: false,

  cardFilterDentistElement: null,
  cardFilterUrgencyLevelElement: null,
};
export default TreatmentToday;
